<template>
    <el-container>
        <el-main class="wrapper__body" style="margin-left: 0px;">
            <!-- <Navbar :is_prodcution="is_prodcution" title="Site" style="width: 100%"></Navbar> -->
            <el-container class="main-section">
                <div class="col-md-12">
                    <h1>News</h1>
                    <hr>
                    <div class="container-fluid">
                        <h2>Featured</h2>
                        <!--ADD FEATURED IMAGE BUTTON-->
                        <el-button @click="dialogVisible = true" icon="el-icon-plus" type="primary" size="mini"> Add Content</el-button>
                        <br>
                        <br>
                        <el-table
                                :data="resources.featured"
                                style="width: 100%"
                                size="small"
                                empty-text="No Contents Yet"
                                v-loading="tableLoadingFeatured"
                                border>
                            <el-table-column
                                    type="index"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">TITLE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.title }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT AUTHOR">
                                <template slot="header">
                                    <span style="color: black;">AUTHOR</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.author }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT DATE">
                                <template slot="header">
                                    <span style="color: black;">DATE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.date }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    :min-width="300"
                                    resizable>
                                <template slot="header">
                                    <span style="color: black;">ACTIONS</span>
                                </template>
                                <template slot-scope="scope">
                                    <el-button type="warning" size="mini" @click="editFeatured(scope.row)">Edit</el-button>
                                    <!-- <el-button type="success" size="mini" @click="statusToggle(scope.row.id, scope.row.active)">Activate</el-button> -->
                                    <el-tooltip content="Delete Featured Content" placement="top"><el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteFeaturedContent(scope.row.id)"></el-button></el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <br>
                    <br>
                    <h1>What's Happening at St. Scho</h1>
                    <!--ADD WHATS GOING ON BUTTON BUTTON-->
                    <el-button @click="dialogVisible2 = true" icon="el-icon-plus" type="primary" size="mini"> Add Content</el-button>
                    <hr>
                    <div class="container-fluid">
                        <el-table
                                :data="resources.whats_happening"
                                style="width: 100%"
                                size="small"
                                empty-text="No Contents Yet"
                                v-loading="tableLoadingWhatsHappening"
                                border>
                                <el-table-column
                                    type="index"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">TITLE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.title }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT AUTHOR">
                                <template slot="header">
                                    <span style="color: black;">AUTHOR</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.author }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT DATE">
                                <template slot="header">
                                    <span style="color: black;">DATE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.date }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    :min-width="300"
                                    resizable>
                                <template slot="header">
                                    <span style="color: black;">ACTIONS</span>
                                </template>
                                <template slot-scope="scope">
                                    <el-button type="warning" size="mini" @click="editWhats(scope.row)">Edit</el-button>
                                    <!-- <el-button type="success" size="mini" @click="statusToggle(scope.row.id, scope.row.active)">Activate</el-button> -->
                                    <el-tooltip content="Delete What's Happening Content" placement="top"><el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteWhatsContent(scope.row.id)"></el-button></el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <br>
                    <br>
                    <h1>Upcoming Events</h1>
                    <!--ADD EVENTS BUTTON-->
                    <el-button @click="dialogVisible3 = true" icon="el-icon-plus" type="primary" size="mini"> Add Content</el-button>
                    <hr>
                    <div class="container-fluid">
                        <el-table
                                :data="resources.upcoming_events"
                                style="width: 100%"
                                size="small"
                                empty-text="No Content Yet"
                                v-loading="tableLoadingUpcoming"
                                border>
                            <el-table-column
                                    type="index"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">TITLE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.title }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="175"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">TYPE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.type == 1">WEBSITE CONTENT</span>
                                    <span v-else-if="scope.row.type == 2">FACEBOOK POST LINK</span>
                                    <span v-else>N/A</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT DATE">
                                <template slot="header">
                                    <span style="color: black;">DATE</span>
                                </template>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.date }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    :min-width="300"
                                    resizable>
                                <template slot="header">
                                    <span style="color: black;">ACTIONS</span>
                                </template>
                                <template slot-scope="scope">
                                    <el-button type="warning" size="mini" @click="editUpcoming(scope.row)">Edit</el-button>
                                    <!-- <el-button type="success" size="mini" @click="statusToggle(scope.row.id, scope.row.active)">Activate</el-button> -->
                                    <el-tooltip content="Delete Upcoming Event Content" placement="top"><el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUpcomingContent(scope.row.id)"></el-button></el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <!--DIALOGS-->
                <el-dialog :title="featured.id === undefined ? 'Add Featured Content' : 'Edit Featured Content'" :visible.sync="dialogVisible" @close="closeFeaturedModal()" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                    <el-form ref="uploadForm" :rules="featured.id === undefined ? rules : rulesEditFeatured" :model="featured" label-width="120px" label-position="top">
                        <el-form-item prop="title" label="Title">
                            <el-input placeholder="Enter Title" v-model="featured.title"></el-input>
                        </el-form-item>
                        <el-form-item prop="content" label="Content">
                            <ckeditor ref="editor" :editor="editor" v-model="featured.content" :config="editorConfig" name="editorData"></ckeditor>
                        </el-form-item>
                        <el-form-item prop="date" label="Date">
                                <el-date-picker
                                    v-model="featured.date"
                                    type="date"
                                    placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                        <el-form-item prop="author" label="Author">
                            <el-input placeholder="Enter Author" v-model="featured.author"></el-input>
                        </el-form-item>
                        <div class="demo-image__preview" v-if="featured.id !== undefined">
                            <el-table
                                :data="featured.pictures"
                                size="small"
                                style="max-height: 300px; overflow-y: scroll;">
                                <el-table-column
                                    :min-width="200">
                                    <template slot="header">
                                        <span style="color: black;">IMAGE</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-image 
                                            :src="scope.row.thumbnail_path"
                                            :preview-src-list="[scope.row.full_path]">
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :max-width="50">
                                    <template slot="header">
                                        <span style="color: black;">ACTION</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="deleteFeaturedContentImage(scope.row.id)"><i class="fa fa-trash"></i></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-form-item label="Photos" prop="files">
                            <el-upload
                                    ref="upload"
                                    action=""
                                    name="file[]"
                                    accept="image/png, image/gif, image/jpeg"
                                    :on-remove="handleRemove"
                                    :on-change="handleChange"
                                    :file-list="featured.fileList"
                                    multiple
                                    :auto-upload="false">
                                <el-button size="small" type="primary">Click to upload</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                            <el-button @click="closeFeaturedModal()">Cancel</el-button>
                            <el-button @click="submitFeaturedContent()" icon="el-icon-check" type="primary"> Upload</el-button>
                        </span>
                </el-dialog>

                <el-dialog :title="whats_happening.id === undefined ? 'Add What\'s Happening at St. Scho Content' : 'Edit What\'s Happening at St. Scho Content'" :visible.sync="dialogVisible2" @close="closeWhatsModal()" :show-close="whats_happening.id !== undefined ? false : true" :close-on-press-escape="false" :close-on-click-modal="whats_happening.id !== undefined ? false : true">
                    <el-form ref="uploadForm2" :rules="rules" :model="whats_happening" label-width="120px" label-position="top">
                        <el-form-item prop="title" label="Title">
                            <el-input placeholder="Enter Title" v-model="whats_happening.title"></el-input>
                        </el-form-item>
                        <el-form-item prop="content" label="Content">
                            <ckeditor ref="editor" :editor="editor" v-model="whats_happening.content" :config="editorConfig" name="editorData"></ckeditor>
                        </el-form-item>
                        <el-form-item prop="date" label="Date">
                                <el-date-picker
                                    v-model="whats_happening.date"
                                    type="date"
                                    placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                        <el-form-item prop="author" label="Author">
                            <el-input placeholder="Enter Author" v-model="whats_happening.author"></el-input>
                        </el-form-item>
                        <div class="demo-image__preview" v-if="whats_happening.id !== undefined">
                            <el-table
                                :data="whats_happening.pictures"
                                size="small"
                                style="max-height: 300px; overflow-y: scroll;">
                                <el-table-column
                                    :min-width="200">
                                    <template slot="header">
                                        <span style="color: black;">IMAGE</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-image 
                                            :src="scope.row.thumbnail_path"
                                            :preview-src-list="[scope.row.full_path]">
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :max-width="50">
                                    <template slot="header">
                                        <span style="color: black;">ACTION</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="deleteWhatsContentImage(scope.row.id)"><i class="fa fa-trash"></i></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-form-item prop="files2">
                            <el-upload
                                    ref="upload"
                                    action=""
                                    name="file[]"
                                    accept="image/png, image/gif, image/jpeg"
                                    :on-remove="handleRemove2"
                                    :on-change="handleChange2"
                                    :file-list="whats_happening.fileList"
                                    multiple
                                    :auto-upload="false">
                                <el-button size="small" type="primary">Click to upload</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                            <el-button @click="closeWhatsModal()">Cancel</el-button>
                            <el-button @click="submitWhatsContent()" icon="el-icon-check" type="primary"> Upload</el-button>
                        </span>
                </el-dialog>

                <el-dialog :title="upcoming_events.id !== undefined ? 'Edit Upcoming Events' : 'Add Upcoming Events Content'" :visible.sync="dialogVisible3" @close="closeUpcomingModal()" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                    <el-form ref="uploadForm3" :rules="rules" :model="upcoming_events" label-width="120px" label-position="top">
                        <el-form-item prop="title" label="Title">
                            <el-input placeholder="Enter Title" v-model="upcoming_events.title"></el-input>
                        </el-form-item>
                        <el-form-item prop="type" label="Content Type">
                            <el-radio v-model="upcoming_events.type" :label="1" @change="handleUpcomingType(1)">Website Content</el-radio>
                            <el-radio v-model="upcoming_events.type" :label="2" @change="handleUpcomingType(2)">Facebook Post</el-radio>
                        </el-form-item>
                        <template v-if="upcoming_events.type == 1">
                            <el-form-item prop="content" label="Content">
                                <ckeditor ref="editor" :editor="editor" v-model="upcoming_events.content" :config="editorConfig" name="editorData"></ckeditor>
                            </el-form-item>
                            <el-form-item prop="date" label="Date">
                                <el-date-picker
                                    v-model="upcoming_events.date"
                                    type="date"
                                    placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item prop="author" label="Author">
                                <el-input placeholder="Enter Author" v-model="upcoming_events.author"></el-input>
                            </el-form-item>
                            <div class="demo-image__preview" v-if="upcoming_events.id !== undefined">
                                <el-table
                                    :data="upcoming_events.pictures"
                                    size="small"
                                    style="max-height: 300px; overflow-y: scroll;">
                                    <el-table-column
                                        :min-width="200">
                                        <template slot="header">
                                            <span style="color: black;">IMAGE</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-image 
                                                :src="scope.row.thumbnail_path"
                                                :preview-src-list="[scope.row.full_path]">
                                            </el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :max-width="50">
                                        <template slot="header">
                                            <span style="color: black;">ACTION</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="deleteUpcomingContentImage(scope.row.id)"><i class="fa fa-trash"></i></el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <el-form-item prop="files3">
                                <el-upload
                                        ref="upload"
                                        action=""
                                        name="file[]"
                                        accept="image/png, image/gif, image/jpeg"
                                        :on-remove="handleRemove3"
                                        :on-change="handleChange3"
                                        :file-list="upcoming_events.fileList"
                                        multiple
                                        :auto-upload="false">
                                    <el-button size="small" type="primary">Click to upload</el-button>
                                </el-upload>
                            </el-form-item>
                        </template>
                        <template v-else-if="upcoming_events.type == 2">
                            <el-form-item prop="link" label="Facebook Post Link">
                                <el-input placeholder="Enter Facebook Post Link" v-model="upcoming_events.link"></el-input>
                            </el-form-item>
                            <el-form-item prop="date" label="Date">
                                <el-date-picker
                                    v-model="upcoming_events.date"
                                    type="date"
                                    placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                            <div class="demo-image__preview" v-if="upcoming_events.id !== undefined">
                                <el-table
                                    :data="upcoming_events.pictures"
                                    size="small"
                                    style="max-height: 300px; overflow-y: scroll;">
                                    <el-table-column
                                        :min-width="200">
                                        <template slot="header">
                                            <span style="color: black;">IMAGE</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-image 
                                                :src="scope.row.thumbnail_path"
                                                :preview-src-list="[scope.row.full_path]">
                                            </el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :max-width="50">
                                        <template slot="header">
                                            <span style="color: black;">ACTION</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="deleteUpcomingContentImage(scope.row.id)"><i class="fa fa-trash"></i></el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <el-form-item prop="files3">
                                <el-upload
                                        ref="upload"
                                        action=""
                                        name="file[]"
                                        accept="image/png, image/gif, image/jpeg"
                                        :on-remove="handleRemove4"
                                        :on-change="handleChange4"
                                        :file-list="upcoming_events.fileList"
                                        :auto-upload="false"
                                        :multiple="false">
                                    <el-button size="small" type="primary">Click to upload</el-button>
                                </el-upload>
                            </el-form-item>
                        </template>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                            <el-button @click="closeUpcomingModal()">Cancel</el-button>
                            <el-button @click="submitUpcomingContent()" icon="el-icon-check" type="primary"> Upload</el-button>
                        </span>
                </el-dialog>
                <!--DIALOGS-->
            </el-container>
        </el-main>
    </el-container>
</template>

<script>
    import { title } from "process";
import Navbar from "../../../components/admin/Navbar";
    import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
    export default {
        props:{
            is_production: Boolean,
        },
        components: { Navbar },
        data () {
            var validateUpload = (rule, value, callback) => {
                if (this.featured.fileList.length < 1) {
                    callback(new Error('Please upload a picture'));
                } else {
                    callback();
                }

            };
            var validateUploadEditFeatured = (rule, value, callback) => {
                if (this.featured.pictures.length == 0 && this.featured.fileList < 1) {
                    callback(new Error('Please upload a picture'));
                } else {
                    callback();
                }

            };
            var validateUpload2 = (rule, value, callback) => {
                if (this.whats_happening.fileList.length < 1) {
                    callback(new Error('Please upload a picture'));
                } else {
                    callback();
                }

            };
            var validateUpload3 = (rule, value, callback) => {
                if (this.upcoming_events.fileList.length < 1 && this.upcoming_events.type == 1) {
                    callback(new Error('Please upload a picture'));
                } else if((this.upcoming_events.fileList.length < 1 && this.upcoming_events.pictures.length == 0) && this.upcoming_events.type == 2) {
                    callback(new Error('Please upload a cover picture'));
                } else {
                    callback();
                }

            };
            return {
                // img: this.$root.folder_name + '/public/assets/img/directory_home.png',
                // contents: [],
                env_wp: this.$root.env_wp.env_wp,
                rules: {
                    files: [
                        { validator: validateUpload, trigger: 'change' },
                    ],
                    files2: [
                        { validator: validateUpload2, trigger: 'change' },
                    ],
                    files3: [
                        { validator: validateUpload3, trigger: 'change' },
                    ],
                },
                rulesEditFeatured: {
                    files: [
                        { validator: validateUploadEditFeatured, trigger: 'change' },
                    ],
                },
                content: {
                    fileList: [],
                    featured_content_title: '',
                    featured_content: '',
                },
                tableLoading: false,
                dialogVisible: false,
                dialogVisible2: false,
                dialogVisible3: false,
                tableLoadingFeatured: false,
                tableLoadingWhatsHappening: false,
                tableLoadingUpcoming: false,
                featured:{
                    title: '',
                    content: '',
                    author: '',
                    date: '',
                    fileList: [],
                },
                whats_happening:{
                    title: '',
                    content: '',
                    date: '',
                    author: '',
                    fileList: [],
                },
                upcoming_events:{
                    title: '',
                    type: 1,
                    content: '',
                    date: '',
                    author: '',
                    link: '',
                    fileList: [],
                },
                resources: {
                    featured: [],
                    whats_happening: [],
                    upcoming_events: []
                },
                editor: ClassicEditor,
                editorConfig: {
                    placeholder: 'Type the content here!',
                    toolbar: {
                        items: [
                            'exportPDF','exportWord', '|',
                            'findAndReplace', 'selectAll', '|',
                            'heading', '|',
                            'bold', 'italic', 'strikethrough', 'underline', 'code', 'subscript', 'superscript', 'removeFormat', '|',
                            'bulletedList', 'numberedList', 'todoList', '|',
                            'outdent', 'indent', '|',
                            'undo', 'redo',
                            '-',
                            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight', '|',
                            'alignment', '|',
                            'link', 'insertImage', 'blockQuote', 'insertTable', //'mediaEmbed', 
                            'codeBlock', 'htmlEmbed', '|',
                            'specialCharacters', 'horizontalLine', 'pageBreak', '|',
                            'textPartLanguage', '|',
                            'sourceEditing'
                        ],
                        shouldNotGroupWhenFull: true
                    },
                    list: {
                        properties: {
                            styles: true,
                            startIndex: true,
                            reversed: true
                        }
                    },
                    heading: {
                        options: [
                            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                        ]
                    },
                    fontFamily: {
                        options: [
                            'default',
                            'Arial, Helvetica, sans-serif',
                            'Courier New, Courier, monospace',
                            'Georgia, serif',
                            'Lucida Sans Unicode, Lucida Grande, sans-serif',
                            'Tahoma, Geneva, sans-serif',
                            'Times New Roman, Times, serif',
                            'Trebuchet MS, Helvetica, sans-serif',
                            'Verdana, Geneva, sans-serif'
                        ],
                        supportAllValues: true
                    },
                    alignment: {
                        options: [
                            'left', 'right', 'center', 'justify'
                        ],
                        supportAllValues: true
                    },
                    fontSize: {
                        options: [ 10, 12, 14, 'default', 18, 20, 22 ],
                        supportAllValues: true
                    },
                    htmlSupport: {
                        allow: [
                            {
                                name: /.*/,
                                attributes: true,
                                classes: true,
                                styles: true
                            }
                        ]
                    },
                    htmlEmbed: {
                        showPreviews: true
                    },
                    link: {
                        decorators: {
                            addTargetToExternalLinks: true,
                            defaultProtocol: 'https://',
                            toggleDownloadable: {
                                mode: 'manual',
                                label: 'Downloadable',
                                attributes: {
                                    download: 'file'
                                }
                            }
                        }
                    },
                    mention: {
                        feeds: [
                            {
                                marker: '@',
                                feed: [
                                    '@apple', '@bears', '@brownie', '@cake', '@cake', '@candy', '@canes', '@chocolate', '@cookie', '@cotton', '@cream',
                                    '@cupcake', '@danish', '@donut', '@dragée', '@fruitcake', '@gingerbread', '@gummi', '@ice', '@jelly-o',
                                    '@liquorice', '@macaroon', '@marzipan', '@oat', '@pie', '@plum', '@pudding', '@sesame', '@snaps', '@soufflé',
                                    '@sugar', '@sweet', '@topping', '@wafer'
                                ],
                                minimumCharacters: 1
                            }
                        ]
                    },
                    removePlugins: [
                        // These two are commercial, but you can try them out without registering to a trial.
                        // 'ExportPdf',
                        // 'ExportWord',
                        'CKBox',
                        'CKFinder',
                        'EasyImage',
                        // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                        // Storing images as Base64 is usually a very bad idea.
                        // Replace it on production website with other solutions:
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                        // 'Base64UploadAdapter',
                        'RealTimeCollaborativeComments',
                        'RealTimeCollaborativeTrackChanges',
                        'RealTimeCollaborativeRevisionHistory',
                        'PresenceList',
                        'Comments',
                        'TrackChanges',
                        'TrackChangesData',
                        'RevisionHistory',
                        'Pagination',
                        'WProofreader',
                        // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                        // from a local file system (file://) - load this site via HTTP server if you enable MathType
                        'MathType'
                    ],
                    // toolbar: ['heading', '|', 'fontSize', 'fontFamily', '|', 'bold', 'italic', 'Underline', 'Strikethrough', 'Highlight', '|', 'alignment', '|', 'numberedList', 'bulletedList', '|', 'link', 'blockQuote', 'insertTable', '|', 'undo', 'redo'],
                    // heading: {
                    //     options: [
                    //         {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
                    //         {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
                    //         {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
                    //         {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'},
                    //         {model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4'},
                    //         {model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5'},
                    //         {model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6'},
                    //     ]
                    // },
                    // ckfinder: {
                    //     uploadUrl: 'api/ckfinder/connector',
                    //     connectorPath: 'api/ckfinder/connector',
                    //     filebrowserBrowseUrl: '/ckfinder/browser',
                    //     filebrowserImageBrowseUrl: 'api/ckfinder/browser?type=Images',
                    //     filebrowserUploadUrl: 'api/ckfinder/connector?command=QuickUpload&type=Files',
                    //     filebrowserImageUploadUrl: 'api/ckfinder/connector?command=QuickUpload&type=Images',
                    //     options: {
                    //         resourceType: 'Images'
                    //     }
                    // }
                },
                custom_modal_title: '',
                customModalVisible: false,
            }
        },
        async mounted() {
            await this.getAllContents();
        },
        methods: {
            async getAllContents(){
                await this.getNewsFeatured();
                await this.getWhatsHappening();
                await this.getUpcomingEvents();
            },
            handleRemove(file, fileList) {
                const index = this.featured.fileList.indexOf(file);
                this.featured.fileList.splice(index, 1);
            },
            handleChange(file, fileList) {
                this.featured.fileList.splice(0, 1);
                this.featured.fileList = fileList;
            },
            handleRemove2(file, fileList) {
                const index = this.whats_happening.fileList.indexOf(file);
                this.whats_happening.fileList.splice(index, 1);
            },
            handleChange2(file, fileList) {
                this.whats_happening.fileList.splice(0, 1);
                this.whats_happening.fileList = fileList;
            },
            handleRemove3(file, fileList) {
                const index = this.upcoming_events.fileList.indexOf(file);
                this.upcoming_events.fileList.splice(index, 1);
            },
            handleChange3(file, fileList) {
                this.upcoming_events.fileList.splice(0, 1);
                if(this.upcoming_events.type > 1){
                    this.upcoming_events.fileList = fileList.slice(-1);
                }else{
                    this.upcoming_events.fileList = fileList;
                }
            },
            handleRemove4(file, fileList) {
                const index = this.upcoming_events.fileList.indexOf(file);
                this.upcoming_events.fileList.splice(index, 1);
            },
            handleChange4(file, fileList) {
                this.upcoming_events.fileList.splice(0, 1);
                this.upcoming_events.fileList = this.upcoming_events.fileList.slice(-0);
                this.upcoming_events.fileList = fileList;
            },
            submitFeaturedContent(){
                if(this.featured.title === ''){
                    this.$swal('Oops', 'Title cannot be empty.', 'error');
                    return;
                }

                if(this.featured.content === ''){
                    this.$swal('Oops', 'Content cannot be empty.', 'error');
                    return;
                }

                if(this.featured.date === ''){
                    this.$swal('Oops', 'Date cannot be empty.', 'error');
                    return;
                }

                if(this.featured.author === ''){
                    this.$swal('Oops', 'Author cannot be empty.', 'error');
                    return;
                }

                var endpoint = this.featured.id === undefined ? 'submit_featured_content' : 'update_featured_content';

                this.$refs['uploadForm'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.featured.id !== undefined) formData.append('id', this.featured.id);
                        formData.append('title', this.featured.title);
                        formData.append('content', this.featured.content);
                        const localDate = new Date(this.featured.date);
                        const adjustedDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000).toISOString().split('T')[0];
                        formData.append('date', adjustedDate);
                        formData.append('author', this.featured.author);
                        if(this.featured.fileList.length > 0){
                            for(var i=0; i < this.featured.fileList.length; i++) {
                                formData.append('files[]', this.featured.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/'+endpoint, formData)
                            .then(res => {
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.getNewsFeatured();
                                this.dialogVisible = false;
                            })
                            .catch(err => {
                                this.resources.featured = [];
                            });
                    }
                });
            },
            getNewsFeatured(){
                this.tableLoadingFeatured = true;
                axios.get(this.env_wp.FOLDER_NAME + '/news_cms/get_featured_contents')
                .then(res =>{
                    this.resources.featured = res.data;
                    this.tableLoadingFeatured = false;
                })
                .catch(err => {
                    this.resources.featured = [];
                    this.tableLoadingFeatured = false;
                });
            },
            editFeatured(featured){
                this.dialogVisible = true;
                this.featured = featured;
                this.featured.fileList = [];
            },
            deleteFeaturedContentImage(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this image?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/delete_featured_content_image', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getNewsFeatured();
                            this.closeFeaturedModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            deleteFeaturedContent(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this Featured Content?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/delete_news_featured_content', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getNewsFeatured();
                            this.closeFeaturedModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            submitWhatsContent(){
                if(this.whats_happening.title === ''){
                    this.$swal('Oops', 'Title cannot be empty.', 'error');
                    return;
                }

                if(this.whats_happening.content === ''){
                    this.$swal('Oops', 'Content cannot be empty.', 'error');
                    return;
                }

                if(this.whats_happening.date === ''){
                    this.$swal('Oops', 'Date cannot be empty.', 'error');
                    return;
                }

                if(this.whats_happening.author === ''){
                    this.$swal('Oops', 'Author cannot be empty.', 'error');
                    return;
                }

                var endpoint = this.whats_happening.id === undefined ? 'submit_whats_happening_content' : 'update_whats_happening_content';

                this.$refs['uploadForm2'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.whats_happening.id !== undefined) formData.append('id', this.whats_happening.id);
                        formData.append('title', this.whats_happening.title);
                        formData.append('content', this.whats_happening.content);
                        const localDate = new Date(this.whats_happening.date);
                        const adjustedDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000).toISOString().split('T')[0];
                        formData.append('date', adjustedDate);
                        formData.append('author', this.whats_happening.author);
                        if(this.whats_happening.fileList.length > 0){
                            for(var i=0; i < this.whats_happening.fileList.length; i++) {
                                formData.append('files[]', this.whats_happening.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/'+endpoint, formData)
                            .then(res => {
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.getAllContents();
                                this.dialogVisible2 = false;
                            })
                            .catch(err => {
                                this.resources.whats_happening = [];
                            });
                    }
                });
            },
            getWhatsHappening(){
                this.tableLoadingWhatsHappening = true;
                axios.get(this.env_wp.FOLDER_NAME + '/news_cms/get_whats_happening_contents')
                .then(res =>{
                    this.resources.whats_happening = res.data;
                    this.tableLoadingWhatsHappening = false;
                })
                .catch(err => {
                    this.resources.whats_happening = [];
                    this.tableLoadingWhatsHappening = false;
                });
            },
            editWhats(whats){
                this.dialogVisible2 = true;
                this.whats_happening = whats;
                this.whats_happening.fileList = [];
            },
            deleteWhatsContentImage(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this image?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/delete_whats_happening_content_image', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getWhatsHappening();
                            this.closeWhatsModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            deleteWhatsContent(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this Whats Happening Content?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/delete_whats_happening_content', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getWhatsHappening();
                            this.closeWhatsModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            submitUpcomingContent(){
                if(this.upcoming_events.type == 1){
                    if(this.upcoming_events.title === ''){
                        this.$swal('Oops', 'Title cannot be empty.', 'error');
                        return;
                    }

                    if(this.upcoming_events.content === ''){
                        this.$swal('Oops', 'Content cannot be empty.', 'error');
                        return;
                    }

                    if(this.upcoming_events.date === ''){
                        this.$swal('Oops', 'Date cannot be empty.', 'error');
                        return;
                    }

                    if(this.upcoming_events.author === ''){
                        this.$swal('Oops', 'Author cannot be empty.', 'error');
                        return;
                    }
                }else{
                    if(this.upcoming_events.title === ''){
                        this.$swal('Oops', 'Title cannot be empty.', 'error');
                        return;
                    }

                    if(this.upcoming_events.link === ''){
                        this.$swal('Oops', 'Facebook Post Link cannot be empty', 'error');
                        return;
                    }

                    if(this.upcoming_events.date === ''){
                        this.$swal('Oops', 'Date cannot be empty.', 'error');
                        return;
                    }
                }

                var endpoint = this.upcoming_events.id === undefined ? 'submit_upcoming_event_content' : 'update_upcoming_event_content';

                this.$refs['uploadForm3'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.upcoming_events.id !== undefined) formData.append('id', this.upcoming_events.id);
                        formData.append('title', this.upcoming_events.title);
                        formData.append('type', this.upcoming_events.type);
                        formData.append('content', this.upcoming_events.content);
                        const localDate = new Date(this.upcoming_events.date);
                        const adjustedDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000).toISOString().split('T')[0];
                        formData.append('date', adjustedDate);
                        formData.append('author', this.upcoming_events.author);
                        formData.append('link', this.upcoming_events.link);
                        if(this.upcoming_events.fileList.length > 0){
                            for(var i=0; i < this.upcoming_events.fileList.length; i++) {
                                formData.append('files[]', this.upcoming_events.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/'+endpoint, formData)
                            .then(res => {
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.getUpcomingEvents();
                                this.dialogVisible3 = false;
                            })
                            .catch(err => {
                                this.resources.upcoming_events = [];
                            });
                    }
                });
            },
            getUpcomingEvents(){
                this.tableLoadingUpcoming = true;
                axios.get(this.env_wp.FOLDER_NAME + '/news_cms/get_upcoming_event_contents')
                .then(res =>{
                    this.resources.upcoming_events = res.data;
                    this.tableLoadingUpcoming = false;
                })
                .catch(err => {
                    this.resources.upcoming_events = [];
                    this.tableLoadingUpcoming = false;
                });
            },
            editUpcoming(upcoming){
                this.dialogVisible3 = true;
                this.upcoming_events = upcoming;
                this.upcoming_events.fileList = [];
                console.log(this.upcoming_events);
            },
            deleteUpcomingContentImage(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this image?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/delete_upcoming_event_content_image', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getUpcomingEvents();
                            this.closeUpcomingModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })

            },
            deleteUpcomingContent(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this Upcoming Event Content?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/news_cms/delete_upcoming_event_content', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getUpcomingEvents();
                            this.closeUpcomingModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            closeFeaturedModal(){
                this.featured = {
                    title: '',
                    content: '',
                    date: '',
                    author: '',
                    fileList: [],
                };
                this.dialogVisible = false;
            },
            closeWhatsModal(){
                if(this.whats_happening.id !== undefined){
                    if(this.whats_happening.pictures.length < 1 && this.whats_happening.fileList.length < 1){
                        this.$swal('Oops', 'Please upload a picture.', 'error');
                        return;   
                    }
                }

                this.whats_happening = {
                    title: '',
                    content: '',
                    date: '',
                    author: '',
                    fileList: [],
                };
                this.dialogVisible2 = false;
            },
            closeUpcomingModal(){
                this.upcoming_events = {
                    title: '',
                    type: 1,
                    content: '',
                    date: '',
                    author: '',
                    link: '',
                    fileList: [],
                };
                this.dialogVisible3 = false;
            },
            handleUpcomingType(type){
                if(type == 1){
                    this.upcoming_events = {
                        title: '',
                        type: 1,
                        content: '',
                        date: '',
                        author: '',
                        link: '',
                        fileList: [],
                    };
                }else{
                    this.upcoming_events = {
                        title: '',
                        type: 2,
                        content: '',
                        date: '',
                        author: '',
                        link: '',
                        fileList: [],
                    };
                }
            }
        }
    }
</script>
